const fileKeys = {
  all: ["file"] as const,
  details: (id: string) => [...fileKeys.all, "detail", id] as const,
};

export { fileKeys };
